import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrlUnsubscribeService {

  constructor(
      private readonly httpClient: HttpClient
  ) {
  }

  public unsubscribe(affiliate: string, token: string): Observable<boolean> {
    return this.httpClient.post<boolean>(
        `/rest/unsubscribe/${encodeURIComponent(affiliate)}/${encodeURIComponent(token)}`,
        null
    );
  }
}
